"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.Nonce = void 0;
var Hash_1 = require("./Hash");
var BigInteger = require("bigi");
var Nonce = /** @class */ (function () {
    function Nonce(nonce) {
        this.nonce = nonce;
    }
    Nonce.read = function (buffer, offset) {
        var nonce1 = BigInteger.fromBuffer(buffer.slice(offset, offset + 8));
        offset += 8;
        var nonce2 = BigInteger.fromBuffer(buffer.slice(offset, offset + 8));
        offset += 8;
        return { value: new Nonce([nonce1, nonce2]), offset: offset };
    };
    Nonce.fromHex = function (hex) {
        var buffer = Buffer.from(hex, 'hex');
        var value = Nonce.read(buffer, 0).value;
        return value;
    };
    Nonce.prototype.getSize = function () {
        return 16;
    };
    Nonce.prototype.toJson = function () {
        return [this.nonce[0].toString(10),
            this.nonce[1].toString(10)];
    };
    Nonce.prototype.write = function (buffer, offset) {
        this.nonce[0].toBuffer(8).copy(buffer, offset);
        offset += 8;
        this.nonce[1].toBuffer(8).copy(buffer, offset);
        offset += 8;
        return offset;
    };
    Nonce.prototype.serialize = function () {
        var size = this.getSize();
        var buffer = Buffer.alloc(size);
        this.write(buffer, 0);
        return buffer;
    };
    Nonce.prototype.toHex = function () {
        return this.serialize().toString('hex');
    };
    return Nonce;
}());
exports.Nonce = Nonce;
var Header = /** @class */ (function () {
    function Header(header) {
        this.header = header;
    }
    Header.read = function (buffer, offset) {
        var version = buffer.readUInt32BE(offset);
        offset += 4;
        var _a = Hash_1.Hash.read(buffer, offset), parent = _a.hash, offset_parent = _a.offset;
        var blockNumber = buffer.readUInt32BE(offset_parent);
        offset = 4 + offset_parent;
        var _b = Hash_1.Hash.read(buffer, offset), commitments = _b.hash, offset_commitments = _b.offset;
        var timestamp = BigInteger.fromBuffer(buffer.slice(offset_commitments, offset_commitments + 8));
        offset = 8 + offset_commitments;
        var difficulty = buffer.readUInt32BE(offset);
        offset += 4;
        var _c = Nonce.read(buffer, offset), nonce = _c.value, offset_nonce = _c.offset;
        var header = {
            version: version,
            parent: parent,
            blockNumber: blockNumber,
            commitments: commitments,
            timestamp: timestamp,
            difficulty: difficulty,
            nonce: nonce
        };
        return { header: new Header(header), offset: offset_nonce };
    };
    Header.fromHex = function (hex) {
        var buffer = Buffer.from(hex, 'hex');
        var header = Header.read(buffer, 0).header;
        return header;
    };
    Header.bigi = function (x) {
        return new BigInteger(x.toString(), undefined, undefined);
    };
    Header.prototype.getSize = function () {
        return 100;
    };
    Header.prototype.write = function (buffer, offset) {
        offset = buffer.writeUInt32BE(this.header.version, offset);
        offset = this.header.parent.write(buffer, offset);
        offset = buffer.writeUInt32BE(this.header.blockNumber, offset);
        offset = this.header.commitments.write(buffer, offset);
        this.header.timestamp.toBuffer(8).copy(buffer, offset);
        offset += 8;
        offset = buffer.writeUInt32BE(this.header.difficulty, offset);
        offset = this.header.nonce.write(buffer, offset);
        return offset;
    };
    Header.prototype.serialize = function () {
        var size = this.getSize();
        var buffer = Buffer.alloc(size);
        this.write(buffer, 0);
        return buffer;
    };
    Header.prototype.toHex = function () {
        return this.serialize().toString('hex');
    };
    Header.prototype.toJson = function () {
        return {
            version: this.header.version,
            parent: this.header.parent,
            blockNumber: this.header.blockNumber,
            commitments: this.header.commitments,
            timestamp: parseInt(this.header.timestamp.toString(10)),
            difficulty: this.header.difficulty,
            nonce: this.header.nonce,
        };
    };
    Header.prototype.toApiJson = function () {
        return {
            version: this.header.version,
            parent: this.header.parent.toString(),
            blockNumber: this.header.blockNumber,
            commitments: this.header.commitments.toString(),
            timestamp: parseInt(this.header.timestamp.toString(10)),
            difficulty: this.header.difficulty,
            nonce: this.header.nonce.toJson(),
        };
    };
    return Header;
}());
exports.Header = Header;
//# sourceMappingURL=Header.js.map